import {FC, forwardRef, useImperativeHandle, useRef, useState} from 'react'
import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

interface Props {
  setFileName: (value: string) => void
  setFiles: (value: any) => void
  isBase64?: boolean
}

export type InputFileRef = {
  reset: () => void;
};

export const InputFile = forwardRef<InputFileRef, Props> (
  ({ setFileName, setFiles, isBase64 = true }, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null);

    useImperativeHandle(ref, () => ({
      reset() {
        if (inputRef.current) {
          inputRef.current.value = '';
        }
      },
    }));
    const {t} = useTranslation()
    const maxFileSize = 20 * 1024 * 1024 // 20MB

    const [isExceed, setIsExceed] = useState(false)

    const getBase64 = (file: any) => {
        setFileName(file.name)
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
            setFiles(reader.result)
        }
        reader.onerror = function (error) {
            alert('Error: ' + error)
        }
    }

    const handleFile = (e: any) => {
        setIsExceed(false)
        if (e.target.files[0]?.size < maxFileSize) {
            if(isBase64){
                getBase64(e.target.files[0])
            }else{
                let file = e.target.files[0]
                setFiles({file})
            }
        }
        else {
            setIsExceed(true)
            e.target.value = null
        }
    }

  return (
    <>
        <Form.Control
            type='file'
            accept='application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg'
            id='upload'
            ref={inputRef}
            onChange={(e: any) => handleFile(e)}
        />

        {isExceed ? <span className='text-danger'>{t('File Exceed 2MB')}</span> : <></>}
    </>
  )
});